import { Observable } from 'rxjs/Observable'

export const visibility$ = Observable
  .fromEvent(document, 'visibilitychange')
  .map(() => !document.hidden)



// WEBPACK FOOTER //
// ./src/scripts/utils/visibility.js